import request from '@/utils/request'

let TeamApi = {
  
    index(data) {
        return request._post('/shop/plus.team.Team/index', data);
    },
    /*设置*/
    setting(data) {
        return request._post('/shop/plus.team.Team/setting', data);
    },
    getSetting(data) {
        return request._get('/shop/plus.team.Team/getSetting', data);
    },
    // 添加团队奖
    settingIndex(data) {
        return request._get('/shop/plus.team.Team/settingIndex', data);
    },
    record(data) {
        return request._get('/shop/plus.team.Team/record', data);
    },
}
export default TeamApi;



// WEBPACK FOOTER //
// ./src/api/team.js